import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconCloseCircle: TIconComponent = props => (
    <Icon viewBox="0 0 20 20" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM6.06694 5.18306L6.00806 5.13107C5.76288 4.94042 5.40836 4.95776 5.18306 5.18306C4.93898 5.42714 4.93898 5.82286 5.18306 6.06694L9.11563 10L5.18306 13.9331L5.13107 13.9919C4.94042 14.2371 4.95776 14.5916 5.18306 14.8169C5.42714 15.061 5.82286 15.061 6.06694 14.8169L10 10.8844L13.9331 14.8169L13.9919 14.8689C14.2371 15.0596 14.5916 15.0422 14.8169 14.8169C15.061 14.5729 15.061 14.1771 14.8169 13.9331L10.8844 10L14.8169 6.06694L14.8689 6.00806C15.0596 5.76288 15.0422 5.40836 14.8169 5.18306C14.5729 4.93898 14.1771 4.93898 13.9331 5.18306L10 9.11563L6.06694 5.18306Z"
            fill="#333333"
        />
    </Icon>
);
